import cn from "classnames";
import { CustomCheckboxProps } from "./CustomCheckbox.types";
import s from "./CustomCheckbox.module.scss";

export const CustomCheckbox = ({ checked, onChange, disabled, className, label }: CustomCheckboxProps) => {
  return (
    <div
      className={cn(s.checkboxContainer, s.checkboxContainer, { [s.disabled]: disabled }, className)}
      onClick={() => onChange?.(!checked)}
    >
      <div className={cn(s.checkbox, { [s.checked]: checked })}>
        <div className={s.checkmark}></div>
      </div>

      {label && <span className={s.label}>{label}</span>}
    </div>
  );
};
